module.exports = __webpack_public_path__ + "img/SKMG14.16a055f6.svg";